import { render, staticRenderFns } from "./FilterTopItems.vue?vue&type=template&id=41d388cd&"
import script from "./FilterTopItems.vue?vue&type=script&lang=js&"
export * from "./FilterTopItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports